import { TechnicalSettings } from "@imi/api-client/index.js";
import { CustomPipeSeries } from "@src/core/api/customPipeSeries";
import { PipeSeriesPreference } from "@src/core/api/pipeSeriesPreference";
import { WaterCharacteristicsPreference } from "@src/core/api/waterCharacteristicsPreferences";
import { engine } from "../..";
import { deleteVector } from "../../helpers/withDelete";
import { pipesRepository } from "../../pipes/pipesRepository";
import { technicalParametersRepository } from "../../technicalParameters/technicalParametersRepository";
import { buildEngineSelectedFilters } from "../helpers/buildEngineSelectedFilters";
import { GetSuggestionsFilters } from "../technicalSelectionRepository";

type GetSuggestionsArgsParamsOptions = {
  categoryId: string;
  customPipeSeries: CustomPipeSeries[];
  filters: GetSuggestionsFilters;
  pipeSeriesPreference: PipeSeriesPreference;
  technicalSettings: TechnicalSettings | null;
  waterCharacteristics: WaterCharacteristicsPreference | null;
};

export function getSuggestionsArgsParams({
  categoryId,
  customPipeSeries,
  filters,
  pipeSeriesPreference,
  technicalSettings,
  waterCharacteristics,
}: GetSuggestionsArgsParamsOptions) {
  const technicalSelection = new engine.TechnicalSelection();
  const currentSelection = buildEngineSelectedFilters({
    filterGroups: filters.filterGroups,
    lastUpdatedFilterId: filters.lastUpdatedFilterId,
  });
  const filterGroups = technicalSelection.getFilters(
    categoryId,
    currentSelection,
  );

  const technicalParameters = new engine.TechnicalParameters();
  const pipesSeries = new engine.PipeSeriesRepository();

  const preferences = {
    ...(technicalSettings ?? {}),
    deviceSizes: filters.deviceSizes ?? technicalSettings?.deviceSizes,
  };

  return {
    cleanup() {
      deleteVector(currentSelection);
      technicalSelection.delete();
      pipesSeries.delete();
      technicalParameters.delete();
    },
    currentSelection,
    params: [
      technicalParametersRepository.init(
        technicalParameters,
        preferences,
        waterCharacteristics,
      ),
      pipesRepository.init(pipesSeries, pipeSeriesPreference, customPipeSeries),
      filterGroups,
    ] as const,
  };
}
